export default "__VITE_ASSET__BC$qRA9a__"